import { DealerData } from '../interfaces/interface.dealer';
import { jsonIf } from '../utils/utils.network';

export type AppointmentData = {
  offerId: string;
  dealerId: string | number;
  dayOfWeek: string;
  timeFrame: string;
};

export const putDealerAppointmentRequest = (appointmentData) => {
  const { day, dealerId, month, offerId, timeFrame, year } = appointmentData;
  const monthName = new Date(year, month - 1, day).toLocaleDateString('en-US', { month: 'long' });

  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/appointment?a=b&api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
      Date: new Date().toUTCString(),
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    mode: 'cors',
    redirect: 'follow',
    body: JSON.stringify({
      DealerId: dealerId,
      OfferId: offerId,
      DayOfWeek: `${day} ${monthName} ${year}`,
      TimeFrame: timeFrame,
    }),
  })
    .then((res) => jsonIf(res))
    .then((res) => {
      return res;
    });
};

export const fetchDealerAppointmentSchedule = (dealerId: string) => {
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/appointmentrequestsettings/${dealerId}?a=b&api_key=${process.env.API_KEY}`, {
    headers: {
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
    redirect: 'follow',
  })
    .then((res) => jsonIf(res))
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error('Error', error);
    });
};

// send lead to dealer
export const postDealerOffer = (dealerId: string, offerId: string) => {
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/offers/${offerId}/dealer/${dealerId}?a=b&api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
      QuestionConversion: 'fury',
      Date: new Date().toUTCString(),
    },
    method: 'POST',
    mode: 'cors',
    redirect: 'follow',
  })
    .then((res) => jsonIf(res))
    .then((res) => {
      return res;
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchDealerInfo = async (dealerId: string): Promise<any> => {
  return await fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/dealers/${dealerId}?api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .catch((e) => {
      throw `Error getting data for dealer ${dealerId} response status ${e}`;
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchDealerActiveStatus = async (dealerId: string): Promise<any> => {
  return await fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/dealers/${dealerId}?api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .catch((e) => {
      throw `Error getting data for dealer ${dealerId} response status ${e}`;
    });
};

export const fetchDealerCobrandingStatus = (cobrandingGroupId: string): Promise<DealerData> => {
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/cobranding/groups/${cobrandingGroupId}?api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .catch((e) => {
      throw `Error getting data for dealer ${cobrandingGroupId} response status ${e}`;
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchDealerInCobrandingGroupStatus = async (dealerId: string, groupId: string): Promise<any> => {
  const dealerUrl = dealerId ? `/dealers/${dealerId}` : '';
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/cobranding/groups/${groupId}${dealerUrl}?api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .catch((e) => {
      throw `Error getting data for dealer ${dealerId} in cobranding group ${groupId} response status ${e}`;
    });
};

export const fetchCobrandingImage = (groupKey: string, itemKey: string = 'cobranding_landing_page.png'): Promise<DealerData> => {
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/webfile/groupKey/${groupKey}?itemKey=${itemKey}&api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .catch((e) => {
      throw `Error getting data for cobranding image ${groupKey}/${itemKey} response status ${e}`;
    });
};

export default { postDealerOffer, putDealerAppointmentRequest, fetchDealerAppointmentSchedule };
